import { Injectable, TemplateRef, signal } from '@angular/core';

/**
 * این سرویس مشکل اساسی z-index مودال‌ها/پاپ‌آپ‌ها را حل می‌کند.
 *
 * چرا این سرویس لازم است؟ چون هر app-glass-card از `isolation: isolate`
 * استفاده می‌کند (برای جلوگیری از نشت افکت‌های blend-mode به بیرون کارت).
 * این یعنی اگر یک مودال/بک‌دراپ (مثل date-picker) به‌صورت یک پاپ‌آپ position:fixed
 * *داخل* یک app-glass-card رندر شود، z-index بالای آن فقط داخل stacking context
 * همان کارت معتبر است و نمی‌تواند روی کارت‌های بعدی صفحه (که stacking context
 * مستقل خودشان را دارند) قرار بگیرد.
 *
 * راه‌حل: مودال به‌جای رندر شدن در محل خودش، محتوایش را در این سرویس ثبت می‌کند؛
 * AppComponent (که بیرون از همه کارت‌ها و در بالاترین سطح DOM است) آن را در یک
 * <ng-container> سراسری نمایش می‌دهد. به این ترتیب z-index مودال همیشه واقعاً
 * بالاترین لایه صفحه خواهد بود.
 */
@Injectable({ providedIn: 'root' })
export class OverlayService {
  readonly activeTemplate = signal<TemplateRef<unknown> | null>(null);

  open(template: TemplateRef<unknown>): void {
    this.activeTemplate.set(template);
  }

  close(): void {
    this.activeTemplate.set(null);
  }

  isOpen(): boolean {
    return this.activeTemplate() !== null;
  }
}
